import Services from './list';
import queryStringLib from 'query-string';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { ACCESS_TOKEN } from 'shared/constant';

export interface RestParams {
  serviceName: string;
  params?: Record<string, string | number>;
  query?: Record<string, any>;
}

export interface SendParams extends RestParams {
  body?: Record<string, any>;
  timeout?: number; // Ms. E.g: 10000
  headers?: object;
}

const pendingRequests: Record<string, AbortController> = {};

type Method = 'GET' | 'POST' | 'PUT' | 'DELETE';

class ClientRestBase {
  private static getService(args: RestParams): { method: Method; url: string } {
    if (!Services[args.serviceName as keyof typeof Services]) {
      throw new Error('Service not found' + args.serviceName);
    }

    const [method, uri] = Services[args.serviceName as keyof typeof Services].split(' ');
    let url: string = `${Services.base_url}${uri}`;

    if (args.params) {
      Object.keys(args.params).map((key) => {
        if (args.params && key && args.params[key]) {
          url = url.replace(`:${key}`, args.params[key].toString());
        }
      });
    }

    if (args.query) {
      url = `${url}?${queryStringLib.stringify(args.query)}`;
    }

    return {
      method: method.toUpperCase() as Method,
      url
    };
  }

  protected sendRequestHandler(args: SendParams): Promise<any> {
    const { url, method } = ClientRestBase.getService({
      params: args.params,
      query: args.query,
      serviceName: args.serviceName
    });

    return new Promise((resolve, reject) => {
      const controller = new AbortController();

      let pendingRequestsKey = url + method;

      if (method.toUpperCase() === 'GET') {
        if (pendingRequests.hasOwnProperty(pendingRequestsKey)) {
          pendingRequests[pendingRequestsKey].abort();
          delete pendingRequests[pendingRequestsKey];
        }
        pendingRequests[pendingRequestsKey] = controller;
      }

      const requestConfig = {
        method,
        url,
        data: args.body ?? {},
        headers: {
          'Content-Type': 'application/json',
          ...(args.headers || {})
        }
      };

      axios.interceptors.request.use((request) => {
        if (localStorage.getItem(ACCESS_TOKEN)) {
          request.headers['Authorization'] = 'Bearer ' + localStorage.getItem(ACCESS_TOKEN);
        }
        // Ensure Content-Type is set for POST requests
        if (request.method?.toLowerCase() === 'post' && !request.headers['Content-Type']) {
          request.headers['Content-Type'] = 'application/json';
        }
        return request;
      });

      axios
        .request(requestConfig)
        .then((response: AxiosResponse<any>) => {
          resolve(JSON.parse(JSON.stringify(response)));
        })
        .catch((err: AxiosError | any) => {
          if (err.name === 'AbortError') {
            return;
          }
          reject(err);
        });
    });
  }
}

export default ClientRestBase;
